<template>
  <section class="section">
    <div class="dg-container">
      <div class="row row-grid align-items-center">
        <p class="hp-title2">
          Roadmap
        </p>
      </div>
      <div class="row row-grid align-items-center mt-4">
        <p class="hp-desc">
          Timeline and Version Update
        </p>
      </div>
      <div class="row row-grid align-items-center">
        <div class="col-md-12">
          <img src="img/homepage/roadmap.png" class="img-fluid floating"/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Roadmap",
};
</script>

<style scoped>

</style>
